<template>
	<div>
		<el-container>
			<el-container>
				<el-main>
					<div class="search-box clearfix">
						<el-form class="form-main" ref="searchForm" :model="searchForm" size="mini" inline label-width="80px" label-position="right">
							<span>
								<el-form-item label="房间" property="roomLocationId">
									<el-cascader
										placeholder="请选择房间"
										:options="TreeData"
										v-model="searchForm.roomLocationId"
										:props="{ value: 'id', label: 'name', children: 'children' }"
										filterable
										clearable
										ref="myCascader"
									>
									</el-cascader>
								</el-form-item>
								<el-form-item label="学号" property="personNo">
									<el-input
										v-model="searchForm.personNo"
										placeholder="请输入学号"
										clearable
										@keyup.enter.native="get_student"
									>
									</el-input>
								</el-form-item>
								<el-form-item label="姓名" property="personName">
									<el-input
										v-model="searchForm.personName"
										placeholder="请输入姓名"
										clearable
										@keyup.enter.native="get_student"
									>
									</el-input>
								</el-form-item>
							</span>

							<div class="search-box-button search-button search_box_button_right">
								<el-button size="mini" type="primary" @click.native.prevent="get_student">查 询</el-button>
								<el-button size="mini"  @click="resetSearchForm">重 置</el-button>
							</div>

						</el-form>
						</div>
						<hr class="search_border">
						<div class="search_tools_div">
						<div class="search_tools_text">数据列表</div>
						<div class="search-tools">
							<el-button size="mini" type="primary" @click.native.prevent="add_student">新 增</el-button>
							<!-- <el-button type="primary" @click="exportExcel">导出</el-button> -->
						</div>
					</div>
					<el-table
					  v-loading='loading'
					  ref="multipleTable"
					  :data="tableData"
					  tooltip-effect="dark"
					  :height="tableHeight"
					  border
					  stripe
					  @selection-change="handleSelectionChange">
						<!-- <el-table-column type="selection" width="50" align="center"></el-table-column> -->
						<el-table-column type="index" width="80" align="center" label="序号"></el-table-column>
						<el-table-column prop="regionName" label="房间" align="center" show-overflow-tooltip>
							<template slot-scope="scope">
								<span>{{scope.row.buildingName}}-{{scope.row.roomNo}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="personName" label="姓名" show-overflow-tooltip align="center"></el-table-column>
						<el-table-column prop="personNo" label="学号" align="center"></el-table-column>
						<el-table-column prop="personSex" label="性别" align="center" show-overflow-tooltip>
							<template slot-scope="scope">
								<el-tag type="primary" v-if="scope.row.personSex == 1">男</el-tag>
								<el-tag type="success" v-if="scope.row.personSex == 0">女</el-tag>
								<el-tag type="warning" v-if="scope.row.personSex == 2">未知</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="identityId" label="类型" show-overflow-tooltip align="center">
							<template slot-scope="scope">
								<el-tag type="primary" v-if="scope.row.identityId == 1">教职工</el-tag>
								<el-tag type="success" v-if="scope.row.identityId == 2">学生</el-tag>
								<el-tag type="warning" v-if="scope.row.identityId == 3">临时人员</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="personFlag" label="成员类型" align="center" show-overflow-tooltip>
							<template slot-scope="scope">
								<el-tag :type="scope.row.personFlag ? 'primary' : 'warning'">{{ scope.row.personFlag ? '缴费代表' : '成员' }}</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="inDate" label="入住日期" show-overflow-tooltip align="center"></el-table-column>
						<!-- <el-table-column prop="lastBalance" label="个账余额" sortable align="center">
							<template slot-scope="scope">
								<span>{{scope.row.lastBalance ? parseFloat(scope.row.lastBalance).toFixed(4) : 0}}</span>
							</template>
						</el-table-column> -->
						<el-table-column label="操作" sortable align="center">
							<template slot-scope="scope">
								<el-button style="margin-right: 10px;" type="text" @click="editHandle(scope.row)">编辑</el-button>
								<el-popconfirm title="确定删除该学生信息吗？" @confirm="delHandle(scope.row)">
									<el-button type="text" slot="reference">删除</el-button>
								</el-popconfirm>
							</template>
						</el-table-column>

					</el-table>

					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handleCurrentChange"
					  layout="total, sizes, prev, pager, next, jumper"
					  :page-sizes="[10, 20, 50, 100]"
					  :current-page="current"
					  :page-size="size"
					  :total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!--新增对话框-->
		<el-dialog
		  :title="title"
		  :visible.sync="dialogVisible"
		  width="700px"
		  :before-close="handleClose"
		  :close-on-click-modal="false">
			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px">

				<el-form-item label="姓名" prop="personName">
					<el-input v-model="editForm.personName" placeholder="请输入姓名" type="text" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="学号" prop="personNo">
					<el-input v-model="editForm.personNo" placeholder="请输入学号" type="text" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="性别" prop="personSex">
					<el-select v-model="editForm.personSex" placeholder="请选择性别">
						<el-option :value="1" label="男"></el-option>
						<el-option :value="0" label="女"></el-option>
						<el-option :value="2" label="未知"></el-option>
					</el-select>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { getLinshi, getTree, get_person_export } from '@/apis/orange'
import { getPersonOnce, addStudent, updateStudent, delStudent } from '@/apis/student'
import { mapGetters, mapActions } from 'vuex';
export default {
	name: "Student",	// 学生列表管理
	data() {
		return {
			nowDate: '',
			loading: true,

			searchForm: {},
			TreeData: [
				{id: 0, name: '数据加载中' }
			],
			delBtlStatu: true,

			total: 0,
			size: 10,
			current: 1,

			dialogVisible: false,
			title: '新增临时人员',
			identArr: [
				// {value: 1, label: '教职工'},
				// {value: 2, label: '学生'},
				// {value: 3, label: '临时人员'},
			],
			editForm: {},

			tableData: [],

			editFormRules: {
				personName: [
					{required: true, message: '请输入学生姓名', trigger: 'blur'}
				],
				personNo: [
					{required: true, message: '请输入学号', trigger: 'blur'}
				],
				personSex: [
					{required: true, message: '请选择性别', trigger: 'blur'}
				],
				identityId: [
					{required: true, message: '请选择身份类型', trigger: 'blur'}
				],
			},

			multipleSelection: [],

			permDialogVisible: false,
			permForm: {},
			defaultProps: {
				children: 'children',
				label: 'machineNum'
			},
			treeSelectLocationId: 0,
			selectedMachineInfo: '',
		}
	},
	computed: {
		...mapGetters('treeData', ['treeData']),
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	created() {
		this.get_student()
		// this.getLocationTree()
		this.fetchTreeData().then(data => {
			this.TreeData = data
		});
		let t = new Date()
		let end = t.getFullYear() + '-' + ('0'+(t.getMonth() + 1)).slice(-2) + '-' + t.getDate()
		this.nowDate = end
	},
	methods: {
		...mapActions('treeData', ['fetchTreeData']),
		exportExcel() {
			const loading = this.$loading({
				text: '加载中...',
			});
			let searchObj = {}
			searchObj = JSON.parse(JSON.stringify(this.searchForm))
			if (searchObj.roomLocationId && searchObj.roomLocationId.length) {
				let room = searchObj.roomLocationId[ searchObj.roomLocationId.length - 1 ].toString()
				// let floo = searchObj.roomLocationId[ searchObj.roomLocationId.length - 2 ] ? searchObj.roomLocationId[ searchObj.roomLocationId.length - 2 ].toString() : false
				// searchObj.roomLocationId = floo ? room.split(floo)[1] : room
				// if (floo) {
				// 	searchObj.roomLocationId = room.split(floo)[1]
				// } else if (room != 0) {
				// 	searchObj.roomLocationId = room
				// }
				searchObj.roomLocationId = room
			} else {
				delete searchObj.roomLocationId
			}
			get_person_export(searchObj).then(res => res.data).then(res => {
				loading.close()
				// console.log(res);
				if (res.code == 200) {
					if (res.data.length) {
						let excelData = res.data.map((it, index) => ({index: index + 1, qy: it.regionName, mc: `${it.buildingName}-${it.roomNo}`, name: it.personName, xh: it.personNo, lx: it.identityName, type: it.personFlag?'缴费代表':'成员', inDate: it.inDate}))
                        this.getExcel(excelData)
					} else {
						this.$message({
							type: 'error',
							message: "没有可导数据"
						})
					}
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		getExcel(excelData) {
            var XLSX = require("xlsx");

            // 创建一个工作表
            const worksheet = XLSX.utils.json_to_sheet(excelData)
            // 创建一个新的工作簿
            const workbook = XLSX.utils.book_new()

            XLSX.utils.book_append_sheet(workbook, worksheet, 'Data')
            // 改写表头   'sku', 'wlms', 'ddsl', 'shsl', 'jhy'
            XLSX.utils.sheet_add_aoa(worksheet, [['序号', '区域', '房间', '姓名', '学号', '类型', '成员类型', '入住时间']], { origin: 'A1' })
            XLSX.writeFileXLSX(workbook, `学生列表${this.nowDate}.xlsx`)
        },
		resetSearchForm() {
			this.current = 1
			this.searchForm = {}
			this.get_student()
		},
		getLocationTree() {
			getTree().then(res => res.data).then(res => {
				this.TreeData = this.adjustCascaderData(res.data)
				// console.log(this.TreeData);
			})
		},
		adjustCascaderData(data) {
			return data.map(item => {
				if (item.children && item.children.length == 0) {
					delete item.children; // 删除空的 children 数组
				} else {
					item.children = this.adjustCascaderData(item.children);
				}
				return item;
			});
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;

			this.delBtlStatu = val.length == 0
		},

		handleSizeChange(val) {
			this.size = val
			this.get_student()
		},
		handleCurrentChange(val) {
			this.current = val
			this.get_student()
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.editForm = {}
		},
		handleClose() {
			this.resetForm('editForm')
		},
		get_student() {
			let searchObj = {}
			searchObj = JSON.parse(JSON.stringify(this.searchForm))
			if (searchObj.roomLocationId && searchObj.roomLocationId.length) {
				let room = searchObj.roomLocationId[ searchObj.roomLocationId.length - 1 ].toString()
				// let floo = searchObj.roomLocationId[ searchObj.roomLocationId.length - 2 ] ? searchObj.roomLocationId[ searchObj.roomLocationId.length - 2 ].toString() : false
				// searchObj.roomLocationId = floo ? room.split(floo)[1] : room
				// if (floo) {
				// 	searchObj.roomLocationId = room.split(floo)[1]
				// } else if (room != 0) {
				// 	searchObj.roomLocationId = room
				// }
				searchObj.roomLocationId = room
			} else {
				delete searchObj.roomLocationId
			} 
			getLinshi({current: this.current, size: this.size, ...searchObj}).then(res => res.data).then(res => {
				this.tableData = res.data.records
				this.total = res.data.total
				this.loading = false
			})
		},
		add_student() {
			this.title = '新增临时人员'
			this.dialogVisible = true
			this.editForm = {}
		},
		editHandle(row) {
			this.title = '编辑临时人员信息'
			getPersonOnce(row.personId).then(res => res.data).then(res => {
				this.editForm = res.data
				this.dialogVisible = true
			})
		},
		delHandle(row) {
			delStudent(row.personId).then(res => res.data).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.$message({
						showClose: true,
						message: '操作成功',
						type: 'success',
					})
					this.get_student()
				}
			})
		},

		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					if (this.editForm.id) {
						updateStudent(this.editForm).then(res => res.data).then(res => {
							
							if (res.code == 200) {
								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
								})
								this.dialogVisible = false
								this.get_student()
							}
						})
					} else {
						addStudent({...this.editForm, deptId: 4, identityId: 3}).then(res => res.data).then(res => {
							// console.log(res);
							if (res.code == 200) {
								this.$message({
									showClose: true,
									message: '操作成功',
									type: 'success',
								})
								this.dialogVisible = false
								this.get_student()
							}
						})
					}
				} else {
					// console.log('error submit!!');
					return false;
				}
			});
		},
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}
.border {
	width: 40px;
	height:40px;
	text-align: center; 
	line-height: 40px;
	border-radius: 50%;
	display: inline-block;
	cursor: pointer;
}
.green {
	border: 1px solid green;
	color: green;
}
.red {
	border: 1px solid red;
	color: red;
}

</style>